import type { ReactElement } from 'react'

import Plugin from '../../templateComponents/Plugin'

export default function Category({ category }: CategoryThemeComponentProps): ReactElement {
  return (
    <div className="template-category">
      <h1>{category.title}</h1>
      <Plugin type="epages.text" _id="category" />
    </div>
  )
}
